import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from './AuthContext';
import { Link } from 'react-router-dom'; // <--- 1. PŘIDAT IMPORT
import contactService from '../services/contactService';
import { toast } from 'sonner';
import { FiMail, FiSend, FiMessageSquare, FiUser, FiArrowLeft } from 'react-icons/fi'; // Přidána ikona šipky
import '../styles/Contact.css';
import SEO from './SEO';

const Contact = () => {
    const { t } = useTranslation();
    const { isLoggedIn } = useContext(AuthContext); // user zde nepotřebujeme, pokud ho nepoužíváme jinde
    
    // ... (zbytek stavů a funkcí zůstává stejný) ...
    const [formData, setFormData] = useState({
        email: '',
        subject: '',
        message: '',
        _gotcha: ''
    });
    
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        // ... (váš existující kód handleSubmit) ...
        e.preventDefault();
        
        if (!isLoggedIn && !formData.email) {
            toast.error(t('contact.emailRequired', { defaultValue: "Vyplňte prosím e-mail" }));
            return;
        }
        if (formData.message.length < 10) {
            toast.error(t('contact.messageTooShort', { defaultValue: "Zpráva je příliš krátká" }));
            return;
        }

        setLoading(true);
        try {
            await contactService.sendMessage(formData);
            toast.success(t('contact.success', { defaultValue: "Zpráva byla úspěšně odeslána!" }));
            
            setFormData({
                email: '',
                subject: '',
                message: '',
                _gotcha: ''
            });
        } catch (err) {
            const errMsg = err.response?.data || t('contact.error', { defaultValue: "Chyba při odesílání" });
            toast.error(errMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-container">
            <SEO 
                title={t('contact.title', { defaultValue: "Kontakt" })}
                description={t('contact.intro', { defaultValue: "Máte otázku, nápad na vylepšení nebo jste našli chybu? Napište nám." })}
            />
            <div className="contact-card">
                <h2>{t('contact.title', { defaultValue: "Napište nám" })}</h2>
                <p className="contact-intro">
                    {t('contact.intro', { defaultValue: "Máte otázku, nápad na vylepšení nebo jste našli chybu? Dejte nám vědět!" })}
                </p>

                <form onSubmit={handleSubmit} className="contact-form">
                    
                    {/* ... (vaše inputy formuláře zůstávají stejné) ... */}
                    {!isLoggedIn && (
                        <div className="form-group">
                            <label htmlFor="email"><FiMail /> Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="vas@email.cz"
                                required
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="subject"><FiMessageSquare /> {t('contact.subject', { defaultValue: "Předmět" })}</label>
                        <select
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                        >
                            <option value="" disabled>{t('contact.selectSubject', { defaultValue: "Vyberte předmět..." })}</option>
                            <option value="Bug">{t('contact.bug', { defaultValue: "Nahlášení chyby" })}</option>
                            <option value="Feature">{t('contact.feature', { defaultValue: "Nápad na vylepšení" })}</option>
                            <option value="Support">{t('contact.support', { defaultValue: "Podpora" })}</option>
                            <option value="Other">{t('contact.other', { defaultValue: "Jiné" })}</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="message"><FiUser /> {t('contact.message', { defaultValue: "Zpráva" })}</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder={t('contact.messagePlaceholder', { defaultValue: "Popište nám, co máte na srdci..." })}
                            rows={5}
                            required
                            maxLength={2000}
                        />
                        <span className="char-count">{formData.message.length}/2000</span>
                    </div>

                    <div style={{ display: 'none', opacity: 0, position: 'absolute', left: '-9999px' }}>
                        <input
                            type="text"
                            name="_gotcha"
                            value={formData._gotcha}
                            onChange={handleChange}
                            tabIndex="-1"
                            autoComplete="off"
                        />
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? (
                            <span className="spinner"></span>
                        ) : (
                            <>
                                <FiSend /> {t('contact.send', { defaultValue: "Odeslat zprávu" })}
                            </>
                        )}
                    </button>
                </form>

                    <div className="contact-back-link">
                        <Link to="/">
                            <FiArrowLeft style={{ marginRight: '5px' }} />  {t('contact.backToHome', { defaultValue: "Zpět na úvodní stránku" })}
                        </Link>
                    </div>
            </div>
        </div>
    );
};

export default Contact;